export type NumberExpectedFormat = 'integer' | 'decimal'

const INTEGER_REGEX = /^[-+]?\d+$/
const DECIMAL_REGEX = /^[-+]?\d*(?:\.\d+)?$/

export const ERROR_MESSAGES = {
    integer: 'Veuillez saisir un nombre entier (sans virgule)',
    decimal: 'Veuillez saisir un nombre valide',
    range: (min?: number, max?: number) => `Veuillez saisir un nombre compris entre ${min} et ${max}`,
}

export const normalizeNumberInput = (raw: string) => raw.replace(',', '.')

export const validateNumber = (
    raw: string,
    expectedFormat: NumberExpectedFormat = 'integer',
    min?: number,
    max?: number,
): { isValid: boolean; error?: string } => {
    const trimmed = raw.trim()
    if (trimmed.length === 0) {
        return { isValid: false, error: undefined }
    }

    const normalized = normalizeNumberInput(trimmed)
    const isInteger = expectedFormat === 'integer'
    const regex = isInteger ? INTEGER_REGEX : DECIMAL_REGEX
    if (!regex.test(normalized)) {
        return { isValid: false, error: isInteger ? ERROR_MESSAGES.integer : ERROR_MESSAGES.decimal }
    }

    const num = Number(normalized)
    if (Number.isNaN(num)) {
        return { isValid: false, error: ERROR_MESSAGES.decimal }
    }
    if ((typeof min === 'number' && num < min) || (typeof max === 'number' && num > max)) {
        return { isValid: false, error: ERROR_MESSAGES.range(min, max) }
    }
    return { isValid: true }
}

export const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value))

export const snapToStep = (value: number, min: number, step: number) => {
    if (!Number.isFinite(step) || step <= 0) return value
    const steps = Math.round((value - min) / step)
    return min + steps * step
}

export const getSliderNumber = (value: number | number[]) => Number(Array.isArray(value) ? value[0] : value)

export const resolveInitialValue = (initialValue: unknown, min: number, max: number) =>
    initialValue != null && Number.isFinite(Number(initialValue)) ? clamp(Number(initialValue), min, max) : min
